"use client";

import { useState } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ErlebenSieUnsereKiRezeptionistinInAktion() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return;
}